<template>
  <div class="OptionTemplate">
    <div class="title">
      <p>Template </p>
      <el-input size="small" v-model="template_name" prefix-icon="el-icon-edit"
                placeholder="Enter Template Name"></el-input>
    </div>

    <table class="table">
      <thead class="head">
      <tr>
        <th></th>
        <th class="head_item" style="width: 60px">Sort</th>
        <th class="head_item" style="width: 180px">Option Name</th>
        <th class="head_item">Item Names</th>
      </tr>
      </thead>
      <tbody class="body">
      <tr class="body_row" v-for="(item,index) in option_items" :key="item.ts?item.ts:item.id">
        <td class="body_item" style="width: 30px">
          <el-button class="arrow" icon="el-icon-delete-solid" @click="onRemoveOption(index)"></el-button>
        </td>
        <td class="body_item">
          <div style="width: 40px; display: flex;flex-direction: column;align-items: center">
            <el-button class="arrow" :disabled="index===0" icon="el-icon-arrow-up"
                       @click="onOrderChange('up',index,item.order)"></el-button>
            <p>{{item.order}}</p>
            <el-button class="arrow" :disabled="index===option_items.length-1" icon="el-icon-arrow-down"
                       @click="onOrderChange('down',index,item.order)"></el-button>
          </div>
        </td>
        <td class="body_item">
          <div>
            <el-input size="small" style="width: 140px" prefix-icon="el-icon-edit" v-model="item.name"
                      @input="onAddName(item.name,index)"
                      placeholder="EN // CN"></el-input>
          </div>
        </td>
        <td class="body_item">
          <div style="display: flex;flex-wrap: wrap">
            <template v-if="item.details.length!==0">
              <div v-for="(sub,idx) in item.details" :key="idx">
                <el-input size="small" style="width: 180px; margin-right: 10px" prefix-icon="el-icon-edit"
                          v-model="sub.name"
                          placeholder="EN // CN">
                  <el-button slot="append" @click="item.details.splice(idx,1)" icon="el-icon-delete-solid"></el-button>
                </el-input>
              </div>
            </template>
            <div style="display: flex; align-items: center">
              <el-input size="small" style="width: 180px; margin-right: 10px" v-model="details_holder[index]"
                        placeholder="EN // CN">
                <el-button slot="append" @click="onAddItem(details_holder[index],index)">Add</el-button>
              </el-input>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="action">
      <el-button class="add" round size="medium" @click="onAddOption">Add Option</el-button>
      <el-button class="save" round size="medium" type="primary" @click="onSaveOption">Save Option</el-button>
    </div>
    <div class="help">
      <i class="el-icon-warning"></i>
      <p>
        Note 1: Use "//" between English and Chinese. For example: "Color // 颜色".
        <br>
        Note 2: Click "Add" to add the item name to the list.
      </p>
    </div>

  </div>
</template>

<script>
  import {detailProductOption, saveProductOption} from "@/utils/api";
  import {adjustArrayOrder} from "@/utils/util";

  export default {
    props: ['tid'],
    data: () => {
      return {
        template_id: '',
        template_name: '',
        name_holder: [],
        details_holder: [],
        option_items: [],
        placeholder_item: {
          name: '',
          order: 1,
          details: [],
          ts: new Date().getTime()
        }
      }
    },
    beforeMount() {
      this.option_items.push(this.placeholder_item);
      this.details_holder.push('');
      this.name_holder.push('');
      if (this.tid !== '') {
        detailProductOption(this.tid).then(res => {
          if (res.errcode === 0) {
            this.template_name = res.option_detail.template_name;
            this.template_id = res.option_detail.template_id;
            this.option_items = res.option_detail.option_items
          } else {
            this.$message.error('Error')
          }
        })
      }
    },
    methods: {
      onAddName(name, index) {
        this.option_items[index].name = name;
      },
      onAddItem(name, index) {
        if (name !== '') {
          this.option_items[index].details.push({name: name});
          this.details_holder[index] = '';
        }
      },
      onAddOption() {
        let place_holder = {};
        place_holder.order = this.option_items.length + 1;
        place_holder.ts = new Date().getTime();
        place_holder.name = '';
        place_holder.details = [];
        this.option_items.push(place_holder);
        this.details_holder.push('');
        this.name_holder.push('')
      },
      onRemoveOption(index) {
        let option_items = [...this.option_items];
        option_items.splice(index, 1);
        this.details_holder.splice(index, 1);
        this.name_holder.splice(index, 1);
        let start_index = 1;
        option_items = option_items.map(v => {
          v.order = start_index;
          start_index++;
          return v
        });
        this.option_items = option_items
      },
      onOrderChange(type, index) {
        this.option_items = adjustArrayOrder(index, this.option_items, type)
      },
      onSaveOption() {
        let option_items = this.option_items;
        let error = 0;
        if (this.template_name === '') {
          error += 1
        }
        option_items.forEach(v => {
          if (v.name.split('//').length !== 2 || v.name.split('//')[0].trim() === '' || v.name.split('//')[1].trim() === '') {
            error += 1
          }
          if (v.details.length === 0) {
            error += 1
          }
          for (let i = 0; i < v.details; i++) {
            if (i.name.split('//').length !== 2 || i.name.split('//')[0].trim() === '' || i.name.split('//')[1].trim() === '') {
              error += 1
            }
          }
        });
        if (error !== 0) {
          this.$message.error('Check you inputs for error.')
        } else {
          this.$showLoading('Processing');
          saveProductOption(
              {
                option_items: option_items,
                template_name: this.template_name,
                template_id: this.template_id
              }
          ).then(res => {
            this.$hideLoading();
            if (res.errcode === 0) {
              this.$message.success('Option Saved');
            } else {
              this.$message.error('Error');
            }
            this.$emit('close')

          })
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_OptionTemplate.scss";
</style>